import {
  ModeIds,
  VARIANT_CHESS,
  VARIANT_CHESS960,
  TimeControl,
} from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import { FaBolt } from "react-icons/fa";
import { FaDragon } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { FaPaperPlane } from "react-icons/fa";
import { FaClock } from "react-icons/fa";
import { showCustomGamePopup, useLobby } from "../../ducks/lobby";
import { BulletIcon } from "../../icons/BulletIcon";
import GameButtonDropdown from "./GameButtonDropdown";
import { formatTime } from "../../util/util";
import Loader from "@/src/components/Loader";
import { useUser } from "@/src/ducks/user";
import { useDaily } from "@/src/ducks/daily";

const Title = ({ children }) => (
  <div className="flex flex-row min-w-[98px] items-center space-x-1 justify-end font-semibold">
    {children[0]}
    <div className="text-sm">{children[1]}</div>
  </div>
);

const Row = ({ children }) => (
  <div className="flex flex-row flex-1 items-center space-x-2">
    {children.map((child) => (
      <div className="flex-1">{child}</div>
    ))}
  </div>
);

function CustomButton({ setShow }) {
  const { t: lobbyT } = useTranslation("lobby");

  function handleCustomClick(e) {
    showCustomGamePopup(true);
    setShow(false);
  }

  return (
    <button
      className="flex justify-center 
                rounded w-full hover:opacity-70 text-altblue-500 p-2 bg-gray-200"
      onClick={handleCustomClick}
    >
      <div className="text-sm">{lobbyT("Custom")}</div>
    </button>
  );
}

function Buttons({ setShow }) {
  function handleClick() {
    setShow(false);
  }

  const { memberLoggedIn } = useUser();
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col space-y-2 pt-2">
        <Row>
          <Title>
            <BulletIcon />
            <div>Bullet</div>
          </Title>
          <GameButtonDropdown
            time={1}
            inc={0}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
          <GameButtonDropdown
            time={2}
            inc={0}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
          <GameButtonDropdown
            time={2}
            inc={1}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
        </Row>
        <Row>
          <Title>
            <FaBolt />
            Blitz
          </Title>
          <GameButtonDropdown
            time={3}
            inc={0}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
          <GameButtonDropdown
            time={5}
            inc={0}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
          <GameButtonDropdown time={5} inc={2} onClick={handleClick} />
        </Row>
        <Row>
          <Title>
            <FaDragon />
            <div>Rapid</div>
          </Title>
          <GameButtonDropdown
            time={10}
            inc={0}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
          <GameButtonDropdown
            time={15}
            inc={0}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
          <GameButtonDropdown
            time={15}
            inc={5}
            variant={VARIANT_CHESS}
            onClick={handleClick}
          />
        </Row>
        {memberLoggedIn && (
          <Row>
            <Title>
              <FaPaperPlane />
              <div className="ml-0.5">{t("Daily")}</div>
            </Title>
            <GameButtonDropdown
              variant={VARIANT_CHESS}
              turnLength={1}
              onClick={handleClick}
            />
            <GameButtonDropdown
              variant={VARIANT_CHESS}
              turnLength={2}
              onClick={handleClick}
            />
            <GameButtonDropdown
              variant={VARIANT_CHESS}
              turnLength={3}
              onClick={handleClick}
            />
          </Row>
        )}
        <CustomButton setShow={setShow} />
      </div>
    </div>
  );
}

export default function ChooseGameDropdown({ show, setShow }) {
  const { time, inc, variant, turnLength, timeControl, modeId, gamesCreated } =
    useLobby();
  const { invites } = useDaily();
  const { id } = useUser();

  let isSentGame = !!gamesCreated.find(
    (game) => time == game.time && inc == game.inc && variant == game.variant
  );

  if (timeControl == TimeControl.DAILY) {
    invites.forEach((invite) => {
      if (
        id === invite.userId &&
        variant == invite.variantId &&
        turnLength == invite.turnLength
      ) {
        isSentGame = true;
      }
    });
  }

  const { t } = useTranslation("common");

  function renderInfo(show) {
    return (
      <div className="flex items-center w-full space-x-4">
        <div className="flex justify-between items-center w-full pr-2">
          <div className="flex items-center space-x-1">
            <FaClock />
            <div>
              {modeId == ModeIds.DAILY ? (
                <span className="ml-0.5">
                  {t("days", { count: turnLength })}
                </span>
              ) : (
                formatTime(time, inc)
              )}
            </div>
            {variant == VARIANT_CHESS960 && (
              <div className="flex items-center font-normal text-altgray-600 space-x-1 pl-1">
                Chess960
              </div>
            )}
          </div>
          {!show && isSentGame && <Loader color="blue" />}
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <div className="flex w-full gap-2">
        <div
          className={`select-none flex cursor-pointer 
                justify-center items-center w-full bg-gray-200 active:opacity-60 md:hover:opacity-75 
                 p-3 px-4 rounded-md`}
          onClick={() => {
            setShow(!show);
          }}
        >
          {renderInfo(show)}

          <div className="flex items-center space-x-4">
            {show ? <FaChevronUp /> : <FaChevronDown />}
          </div>
        </div>
      </div>
      {show && <Buttons setShow={setShow} />}
    </div>
  );
}
